import { render, staticRenderFns } from "./GoldAmount.vue?vue&type=template&id=0da12d73&scoped=true&"
import script from "./GoldAmount.vue?vue&type=script&lang=js&"
export * from "./GoldAmount.vue?vue&type=script&lang=js&"
import style0 from "./GoldAmount.vue?vue&type=style&index=0&id=0da12d73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da12d73",
  null
  
)

export default component.exports